import React from 'react';
import NoRwsales from './NoRwSales';
import Rwsales from './RwSales';
import { useQuery } from 'react-query';
import { getRwsalesLeads } from '../../api/services'; // Add API call for channel partners
import { LinearProgress } from '@mui/material';

const RwsalesPage: React.FC = () => {
    // Fetch Rwsales data
    const { data: RwsalesData, isLoading: isLoadingRwsales, error: RwsalesError, refetch: refetchRwsales } = useQuery('getRwsales', getRwsalesLeads);

    const combinedData = [
        ...(RwsalesData?.data || []), 
    ];


    if (combinedData.length === 0) {
        return <NoRwsales />;
    }

    return <Rwsales RwsalesData={combinedData} onDelete={() => { refetchRwsales();  }} />;
};

export default RwsalesPage;
